import minutesToHours from 'utils/minutes-to-hours';

interface Props {
    input: {
        value: any;
    };
}

const RenderValueHours = ({ input: { value } }: Props): any =>
    minutesToHours(value);

export default RenderValueHours;
